import { render, staticRenderFns } from "./pieGroup.vue?vue&type=template&id=1ef5b742&scoped=true&"
import script from "./pieGroup.vue?vue&type=script&lang=js&"
export * from "./pieGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef5b742",
  null
  
)

export default component.exports